import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeAccount'
})
export class TypeAccountPipe implements PipeTransform {

  transform(arr: any, code: any): any {
    if ( code == '' || code == null || code == undefined || code == 'Type' || code == 'All' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.type == code
      })
    }
  }

}
